<template>
<div class="preview-image-wrapper" v-show="visible">
  <el-dialog size="tiny"
    :visible.sync="isShow"
    @close='handleClose'
  >
     <img width="100%" :src="imageUrl" alt>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: 'PreviewImage',
  props: {
    imageUrl: {
      type: String
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return{
      isShow: this.visible
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style>

</style>